// extracted by mini-css-extract-plugin
export default {"Wrapper":"VideoCarousel_Wrapper__EJG3O","Video":"VideoCarousel_Video__ZN-Sa","CarouselBackground":"VideoCarousel_CarouselBackground__hZGAO"};